import { clamp } from './creatorTimeline';

export function canvasGestureTransform(initial, gesture, point, size) {
  const next = { ...initial };
  const guides = {};
  if (gesture.mode === 'position') {
    let dx = point.x - gesture.x, dy = point.y - gesture.y;
    if (point.shift) { if (Math.abs(dx) >= Math.abs(dy)) dy = 0; else dx = 0; }
    next.x = clamp(initial.x + dx / size.width, -2, 3);
    next.y = clamp(initial.y + dy / size.height, -2, 3);
    for (const key of ['x', 'y']) {
      const dimension = key === 'x' ? size.width : size.height;
      const nearest = [0, .05, .5, .95, 1].find(value => Math.abs(next[key] - value) * dimension < 6);
      if (nearest !== undefined) { next[key] = nearest; guides[key] = nearest; }
    }
  } else if (gesture.mode === 'scale') {
    const distance = Math.hypot(point.x - gesture.centerX, point.y - gesture.centerY);
    next.scale = clamp(initial.scale * distance / Math.max(1, Math.hypot(gesture.x - gesture.centerX, gesture.y - gesture.centerY)), .05, 5);
    if (point.shift) next.scale = Math.round(next.scale * 10) / 10;
  } else if (gesture.mode === 'rotation') {
    const angle = Math.atan2(point.y - gesture.centerY, point.x - gesture.centerX) - Math.atan2(gesture.y - gesture.centerY, gesture.x - gesture.centerX);
    next.rotation = clamp(initial.rotation + angle * 180 / Math.PI, -360, 360);
    if (point.shift) next.rotation = Math.round(next.rotation / 15) * 15;
  }
  return { transform: next, guides };
}

export function visualSize(asset, clip, canvas, scale, textSize) {
  if (clip.text) return textSize || { width: clip.text.size * scale * Math.max(1, clip.text.content.length * .55), height: clip.text.size * scale * 1.2 };
  const width = asset?.width || canvas.width, height = asset?.height || canvas.height;
  const factor = (clip.transform.fit === 'fill' ? Math.max : Math.min)(canvas.width / width, canvas.height / height) * scale;
  return { width: width * factor, height: height * factor };
}
